document.addEventListener('DOMContentLoaded', () => {

  const initializeCardColorways = (group) => {

    if (
      group.dataset.colorwaysInitialized === 'true'
    ) {
      return;
    }

    group.dataset.colorwaysInitialized = 'true';


    const card =
      group.closest('.card-wrapper');

    if (!card) return;


    const swatches =
      group.querySelectorAll(
        '[data-card-colorway-swatch]'
      );


    const cardImages =
      card.querySelectorAll(
        '.card__media img'
      );


    const cardLinks =
      card.querySelectorAll(
        '.card__heading a, .card__media a, a.full-unstyled-link'
      );


    const compareButton =
      card.querySelector(
        '[data-ml-compare-button]'
      );


    if (
      !swatches.length ||
      !cardImages.length
    ) {
      return;
    }


    const primaryImage =
      cardImages[0];


    const secondaryImage =
      cardImages[1] || null;


    let selectedSwatch =
      group.querySelector(
        '[data-card-colorway-swatch].is-active'
      ) ||
      swatches[0];


    /* =======================================================
       IMAGE
       ======================================================= */

    const setImage = (
      image,
      src,
      srcset
    ) => {

      if (
        !image ||
        !src
      ) {
        return;
      }


      image.src =
        src;


      if (srcset) {

        image.srcset =
          srcset.trim();

      }

      else {

        image.removeAttribute(
          'srcset'
        );

      }
    };


    /* =======================================================
       NORMALIZE SHOPIFY PRODUCT URL
       ======================================================= */

    const getProductJsonUrl = (
      productUrl
    ) => {

      try {

        const url =
          new URL(
            productUrl,
            window.location.origin
          );


        /*
          Remove query string such as:
          ?variant=12345
        */

        const pathname =
          url.pathname.replace(
            /\.js$/,
            ''
          );


        return `${pathname}.js`;

      }

      catch (error) {

        return null;

      }
    };


    /* =======================================================
       PRICE
       ======================================================= */

    const formatProductPrice = (
      product
    ) => {
      if (
        !product ||
        !Array.isArray(product.variants)
      ) {
        return '';
      }

      const minimumRealPrice = 4000;

      const realPrices =
        product.variants
          .map((variant) => {
            return Number(
              variant.price
            );
          })
          .filter((price) => {
            return (
              Number.isFinite(price) &&
              price >= minimumRealPrice
            );
          });

      if (!realPrices.length) {
        return '';
      }

      const lowestPrice =
        Math.min(...realPrices);

      const dollars =
        lowestPrice / 100;

      const formatted =
        Number.isInteger(dollars)
          ? dollars.toLocaleString(
              'en-US',
              {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }
            )
          : dollars.toLocaleString(
              'en-US',
              {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            );

      return `From ${formatted}`;
    };


    /* =======================================================
       FIND SIZE OPTION
       ======================================================= */

    const getProductSizes = (
      product
    ) => {

      if (
        !product ||
        !Array.isArray(
          product.options
        )
      ) {
        return [];
      }


      /*
        Shopify's /products/handle.js
        may return option objects.
      */

      const sizeOption =
        product.options.find(
          (option) => {

            if (
              typeof option ===
              'string'
            ) {
              return (
                option
                  .trim()
                  .toLowerCase() ===
                'size'
              );
            }


            return (
              option &&
              String(
                option.name || ''
              )
                .trim()
                .toLowerCase() ===
                'size'
            );
          }
        );


      /*
        If Shopify returned a full
        option object with values,
        use those directly.
      */

      if (
        sizeOption &&
        typeof sizeOption ===
          'object' &&
        Array.isArray(
          sizeOption.values
        )
      ) {

        return sizeOption.values
          .map(
            (value) =>
              String(value).trim()
          )
          .filter(Boolean);
      }


      /*
        Otherwise determine the Size
        option position and collect its
        values from the variants.
      */

      let sizePosition = -1;


      product.options.forEach(
        (option, index) => {

          const name =
            typeof option ===
              'string'
              ? option
              : option?.name;


          if (
            String(name || '')
              .trim()
              .toLowerCase() ===
            'size'
          ) {

            sizePosition =
              index;

          }
        }
      );


      if (
        sizePosition === -1 ||
        !Array.isArray(
          product.variants
        )
      ) {
        return [];
      }


      const sizes =
        product.variants
          .map(
            (variant) =>
              variant.options?.[
                sizePosition
              ]
          )
          .filter(Boolean);


      return [
        ...new Set(sizes)
      ];
    };


    /* =======================================================
       UPDATE COMPARE BUTTON
       ======================================================= */

    const updateCompareData = async (
      swatch
    ) => {

      if (!compareButton) {
        return;
      }


      const productUrl =
        swatch.dataset.colorwayUrl;


      if (!productUrl) {
        return;
      }


      const jsonUrl =
        getProductJsonUrl(
          productUrl
        );


      if (!jsonUrl) {
        return;
      }


      try {

        const response =
          await fetch(
            jsonUrl,
            {
              credentials:
                'same-origin'
            }
          );


        if (!response.ok) {

          throw new Error(
            'Could not load colorway product.'
          );

        }


        const product =
          await response.json();


        const primarySrc =
          swatch.dataset
            .colorwayPrimaryImage ||
          product.featured_image ||
          '';


        const sizes =
          getProductSizes(
            product
          );


        /*
          Replace ALL of the data
          Compare reads.
        */

        compareButton.dataset.productId =
          String(
            product.id || ''
          );


        compareButton.dataset.productTitle =
          product.title || '';


        compareButton.dataset.productUrl =
          productUrl;


        compareButton.dataset.productImage =
          primarySrc;


        compareButton.dataset.productPrice =
          formatProductPrice(
            product
          );


        compareButton.dataset.productSizes =
          sizes.join('||');


        /*
          Since this is now a different
          product/colorway, reset the
          visual Compare state.

          ml-compare.js will take over
          normally when clicked.
        */

        compareButton.classList.remove(
          'is-selected'
        );


        compareButton.setAttribute(
          'aria-pressed',
          'false'
        );


        const compareLabel =
          compareButton.querySelector(
            '[data-ml-compare-label]'
          );


        if (compareLabel) {

          compareLabel.textContent =
            'Compare';

        }

      }

      catch (error) {

        console.error(
          'Could not update Compare colorway data:',
          error
        );

      }
    };


    /* =======================================================
       APPLY COLORWAY
       ======================================================= */

    const applySwatch = (
      swatch,
      updateLinks = false
    ) => {

      const primarySrc =
        swatch.dataset
          .colorwayPrimaryImage;


      const primarySrcset =
        swatch.dataset
          .colorwayPrimarySrcset;


      const secondarySrc =
        swatch.dataset
          .colorwaySecondaryImage;


      const secondarySrcset =
        swatch.dataset
          .colorwaySecondarySrcset;


      const productUrl =
        swatch.dataset
          .colorwayUrl;


      setImage(
        primaryImage,
        primarySrc,
        primarySrcset
      );


      if (secondaryImage) {

        if (secondarySrc) {

          setImage(
            secondaryImage,
            secondarySrc,
            secondarySrcset
          );


          secondaryImage.style.display =
            '';

        }

        else {

          secondaryImage.style.display =
            'none';

        }

      }


      if (
        updateLinks &&
        productUrl
      ) {

        cardLinks.forEach(
          (link) => {

            link.href =
              productUrl;

          }
        );

      }
    };


    /* =======================================================
       RESTORE SELECTED COLORWAY AFTER HOVER
       ======================================================= */

    const restoreSelected =
      () => {

        if (selectedSwatch) {

          applySwatch(
            selectedSwatch,
            false
          );

        }
      };


    /* =======================================================
       COLORWAY EVENTS
       ======================================================= */

    swatches.forEach(
      (swatch) => {


        /*
          HOVER PREVIEW

          IMPORTANT:
          This changes only the visual
          image. It does NOT change
          Compare data.
        */

        swatch.addEventListener(
          'mouseenter',
          () => {

            applySwatch(
              swatch,
              false
            );

          }
        );


        swatch.addEventListener(
          'mouseleave',
          restoreSelected
        );


        swatch.addEventListener(
          'focus',
          () => {

            applySwatch(
              swatch,
              false
            );

          }
        );


        swatch.addEventListener(
          'blur',
          restoreSelected
        );


        /*
          ACTUAL COLORWAY SELECTION
        */

        swatch.addEventListener(
          'click',
          async (event) => {

            event.preventDefault();
            event.stopPropagation();


            selectedSwatch =
              swatch;


            swatches.forEach(
              (item) => {

                item.classList.remove(
                  'is-active'
                );


                item.removeAttribute(
                  'aria-current'
                );

              }
            );


            swatch.classList.add(
              'is-active'
            );


            swatch.setAttribute(
              'aria-current',
              'true'
            );


            /*
              Change the card's image
              and product links.
            */

            applySwatch(
              swatch,
              true
            );


            /*
              NEW:
              Change the product data
              used by Compare.
            */

            await updateCompareData(
              swatch
            );

          }
        );

      }
    );


    /* =======================================================
       MORE COLORWAYS TOGGLE
       ======================================================= */

    const toggle =
      group.querySelector(
        '[data-card-colorways-toggle]'
      );


    if (toggle) {

      toggle.addEventListener(
        'click',
        (event) => {

          event.preventDefault();
          event.stopPropagation();


          const isExpanded =
            group.classList.toggle(
              'is-expanded'
            );


          const isMobile =
            window
              .matchMedia(
                '(max-width: 749px)'
              )
              .matches;


          toggle.setAttribute(
            'aria-expanded',
            String(isExpanded)
          );


          if (isExpanded) {

            toggle.textContent =
              toggle.dataset.lessText;

          }

          else {

            toggle.textContent =
              isMobile
                ? toggle.dataset
                    .mobileMoreText
                : toggle.dataset
                    .desktopMoreText;

          }

        }
      );
    }

  };


  /* =========================================================
     INITIALIZE
     ========================================================= */

  document
    .querySelectorAll(
      '[data-card-colorways]'
    )
    .forEach(
      initializeCardColorways
    );

});